import { getServices } from '~/db/services';

export const useConfigLoadFromNetwork = async () => {
  const { $db } = useNuxtApp();
  const { configsService } = getServices($db);
  const config = useConfigStore();
  const _fetchData = async (url) => {
    const request = await useApiFetch(
      url,
      {
        method: 'GET',
      },
      true
    );
    if (request.error) {
      throw request.error;
    } else {
      return request.result;
    }
  };
  try {
    const loadedDataConfig = await _fetchData(`/appconfigurations`);
    await configsService.put({
      id: '1',
      data: loadedDataConfig,
    });
    config.forceUpdateRawValue(loadedDataConfig);
    return true;
  } catch (e) {
    return false;
  }
};
